import {Component, Injector, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ClaimService} from "../../../../services/claim.service";
import {Claim} from "../../../../model/claim.model";
import {ClaimsBaseComponent} from "../../../claim-base.component";
import {DatePipe} from "@angular/common";
import {DocumentField} from '../../../../model/document-field';
import {ClaimTypes} from '../../../../model/claim-type.model';
import {DocumentHelperService} from "../../../../services/document-helper.service";
import {DentalExpenses} from "../../../../model/domestic-helper/dental-expenses.model";

@Component({
    selector: 'app-summary-dental-expense',
    templateUrl: './summary-dental-expense.component.html',
    styleUrls: ['./summary-dental-expense.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class SummaryDentalExpenseComponent extends ClaimsBaseComponent implements OnInit {

    claim: Claim;
    dentalExpenses: DentalExpenses
    listOfDocuments: DocumentField[] = [];

    constructor(private claimService: ClaimService,
                private documentHelperService: DocumentHelperService,
                private injector : Injector) {

        super(injector);
        this.claim = this.claimService.getClaim();
        this.dentalExpenses = this.claim.getClaimDomesticHelper().getDentalExpenses();
        this.listOfDocuments = this.documentHelperService.getListOfDocuments(this.claimService.claim.getDocumentForm().documents,
            this.documentHelperService.getDocumentFormBuilder(ClaimTypes[ClaimTypes.CLAIM_TYPE_DMH_DENTAL]).getRequiredDocuments(),
            ClaimTypes[ClaimTypes.CLAIM_TYPE_DMH_DENTAL]);
    }
    
    ngOnInit() { }

    returnYesOrNo(value: string) {
        if ('Yes' === value) {
            return this.translate.instant("claimSection.generalLabels.radioButtonLabels.yes");
        } else {
            if ('No' === value) {
                return this.translate.instant("claimSection.generalLabels.radioButtonLabels.no");
            }
        }
        return '';
    }
    returnYesOrNoBoolean(value: boolean) {
        if (value) {
            return this.translate.instant("claimSection.generalLabels.radioButtonLabels.yes");
        } else {
            if (!value) {
                return this.translate.instant("claimSection.generalLabels.radioButtonLabels.no");
            }
        }
        return '';
    }

    getDate(dt: Date) {
        if (dt && dt != null) {
            return new DatePipe('en-US').transform(dt, "dd/MM/yyyy");
        }
        else {
            return "";
        }
    }

}
